import type { Node } from "@xyflow/react";
import { type Cluster, type ExplodeNodeData, NodeRole } from "../../types";
import { OVERLAY_Z, ZONE_LEFT_OFFSET, ZONE_ROWS, ZONE_WIDTH } from "./graphLayout";
import { graphNode } from "./graphNode";

export const zoneTitleNode = ({
    cluster,
    index,
    centerX,
    tops,
}: {
    cluster: Cluster;
    index: number;
    centerX: number;
    tops: [number, number];
}): Node<ExplodeNodeData> => {
    const col = Math.floor(index / ZONE_ROWS);
    const row = index % ZONE_ROWS;
    return graphNode(
        `ttl-${cluster.field}`,
        centerX + ZONE_LEFT_OFFSET + col * ZONE_WIDTH,
        tops[row],
        {
            label: cluster.label,
            role: NodeRole.TITLE,
            count: cluster.distinctCount,
            title: true,
            overlay: { field: cluster.field, label: cluster.label },
            selection: [],
        },
        OVERLAY_Z,
    );
};
